import EventHistoryContainer from './event-history.container';

export default EventHistoryContainer;
